import { render, staticRenderFns } from "./property-view.vue?vue&type=template&id=308fd948&scoped=true"
import script from "./property-view.vue?vue&type=script&lang=js"
export * from "./property-view.vue?vue&type=script&lang=js"
import style0 from "./property-view.vue?vue&type=style&index=0&id=308fd948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308fd948",
  null
  
)

export default component.exports